// extracted by mini-css-extract-plugin
export default {"modal-body":"modal-body-zcqXmuI"};